@if (isMobile) {
    <h2 class="mob-title statistics-title statistics-icon">
        <prl-label value="label.menu.stats"/>
    </h2>
}

@if (isAffiliatePayable) {
    <prl-balance
            [merchantBalance]="this.financeService.getSelectedMerchant()"
            [merchantPRProperties]="this.financeService.getSelectedMerchantProperties()"
            [balancePerMerchant]="paymentsPerMerchant"
    ></prl-balance>
}

<mat-accordion>

    <prl-panel heading="label.finance.transactions.heading">
        @if (isDataLoaded) {
            <prl-payment-history [balancePerMerchant]="paymentsPerMerchant"></prl-payment-history>
        }
    </prl-panel>

    @if (isAffiliatePayable) {
        @if (showPaymentAccount) {
            <prl-panel heading="label.finance.payment.account.heading">
                <prl-payment-account></prl-payment-account>
            </prl-panel>
        }

        @if (financeService.getTotalPaymentRequestProperties()?.showPaymentRequest) {
            <prl-panel #paymentRequests (expandedChange)="onExpandPaymentRequest($event)"
                       heading="label.finance.payment.request.heading">
                <prl-payment-requests [balancePerMerchant]="this.paymentsPerMerchant"
                                      ></prl-payment-requests>
            </prl-panel>
        }
    }

</mat-accordion>
